module.exports = __webpack_public_path__ + "static/media/wtb2.9d6a930f.jpg";